<template>
  <v-container>
    <v-col>
      <p>
        You will first listen to a speaker auditioning to be a podcast host
        reading a passage that is approximately 30 seconds long. The passage
        will contain sentences spoken with different intonation patterns. Here
        is an example of the same sentence spoken with two different intonation
        patterns:
      </p>
      <v-row justify="center" class="mt-4 mb-8">
        <v-btn @click="play(1)" class="mr-4" :disabled="isPlaying"
          >Practice Type 1 <v-icon>play_circle_filled</v-icon></v-btn
        >

        <v-btn @click="play(2)" :disabled="isPlaying"
          >Practice Type 2 <v-icon>play_circle_filled</v-icon></v-btn
        >
      </v-row>
      <p>
        After listening, you will be asked some questions about what the story
        and the speaker telling the story.
      </p>
      <v-btn
        @click="next"
        :disabled="isPlaying || sf1_played == false || sf2_played == false"
        >next <v-icon>chevron_right</v-icon></v-btn
      >
    </v-col>
  </v-container>
</template>

<script>
import { Howl, Howler } from "howler";
import {ref} from "@vue/composition-api";
import Vue from "vue";
import router from "@/router";
import store from "@/store";
export default {
  setup() {
    const next = () => {
      store.commit("setLocked", false);
      router.push("/experiment");
    };

    const isPlaying = ref(false);
    const sf1_played = ref(false);
    const sf2_played = ref(false);
    const play = (v) => {
      let soundFile;
      if (v == 1) {
        soundFile = "audio/practice/AS_practice1.mp3";
      } else {
        soundFile = "audio/practice/AS_practice2.mp3";
      }
      Howler.stop();
      isPlaying.value = true;
      var sound = new Howl({
        src: soundFile,
        volume: 1,
        onload: () => {
          sound.play();
          if (v == 1) {
            sf1_played.value = true;
          } else {
            sf2_played.value = true;
          }
        },
        onloaderror: () => {
          isPlaying.value = false;
          Vue.prototype.$dialog.error({
            text: "Could not load sound file",
            title: "Error",
          });
        },
        onend: () => {
          isPlaying.value = false;
        },
      });
    };

    return { next, play, isPlaying, sf1_played, sf2_played };
  },
};
</script>